import React from "react";
import { ModeRendererProps } from "./types";

export function VasarelyMondrianMode({ brand }: ModeRendererProps) {
  // Precision grids and optical balance; minimalism for governance
  const primaryColors = [brand.aqua, brand.violet, brand.amber, brand.white];
  
  return (
    <g>
      {/* Base Mondrian grid */}
      <rect x="0" y="0" width="794" height="1123" fill={brand.paper} />
      
      {/* Large blocks with primary colors */}
      <rect x="60" y="80" width="280" height="180" fill={brand.deep} stroke={brand.black} strokeWidth="4" />
      <rect x="360" y="80" width="180" height="180" fill={brand.aqua} stroke={brand.black} strokeWidth="4" />
      <rect x="560" y="80" width="160" height="360" fill={brand.violet} stroke={brand.black} strokeWidth="4" />
      
      <rect x="60" y="280" width="120" height="160" fill={brand.amber} stroke={brand.black} strokeWidth="4" />
      <rect x="200" y="280" width="140" height="160" fill={brand.white} stroke={brand.black} strokeWidth="4" />
      <rect x="360" y="280" width="180" height="160" fill={brand.deep} stroke={brand.black} strokeWidth="4" />
      
      {/* Vasarely optical distortions - nested squares creating depth */}
      {Array.from({ length: 8 }).map((_, i) => {
        const size = 140 - i * 16;
        const offset = i * 8;
        return (
          <rect
            key={`optical-1-${i}`}
            x={130 + offset}
            y={350 + offset}
            width={size}
            height={size}
            fill="none"
            stroke={brand.aqua}
            strokeWidth="1.5"
            opacity={0.9 - i * 0.1}
          />
        );
      })}
      
      {/* Additional grid sections */}
      <rect x="60" y="460" width="280" height="220" fill={brand.white} stroke={brand.black} strokeWidth="4" />
      <rect x="360" y="460" width="180" height="220" fill={brand.aqua} stroke={brand.black} strokeWidth="4" />
      <rect x="560" y="460" width="160" height="220" fill={brand.deep} stroke={brand.black} strokeWidth="4" />
      
      {/* Op-art circle distortion */}
      {Array.from({ length: 12 }).map((_, i) => {
        const r = 10 + i * 8;
        return (
          <circle
            key={`optical-2-${i}`}
            cx={450}
            cy={570}
            r={r}
            fill="none"
            stroke={i % 2 === 0 ? brand.violet : brand.amber}
            strokeWidth="2"
            opacity={0.7}
          />
        );
      })}
      
      {/* Bottom section with more rectangles */}
      <rect x="60" y="700" width="140" height="180" fill={brand.violet} stroke={brand.black} strokeWidth="4" />
      <rect x="220" y="700" width="120" height="180" fill={brand.white} stroke={brand.black} strokeWidth="4" />
      <rect x="360" y="700" width="180" height="180" fill={brand.amber} stroke={brand.black} strokeWidth="4" />
      <rect x="560" y="700" width="160" height="180" fill={brand.aqua} stroke={brand.black} strokeWidth="4" />
      
      {/* Small optical grid overlay */}
      {Array.from({ length: 5 }).map((_, row) =>
        Array.from({ length: 3 }).map((_, col) => (
          <rect
            key={`grid-${row}-${col}`}
            x={230 + col * 40}
            y={720 + row * 32}
            width={32}
            height={28}
            fill="none"
            stroke={brand.deep}
            strokeWidth="1"
            opacity={0.4}
          />
        ))
      )}
    </g>
  );
}
